import PropTypes from "prop-types";
import React, { useState } from "react";
import { Modal, Button, Select, TextInput } from "@opendate-app/setlist";

const EditGuestModal = ({ guest, lists, submitting, onClose, onSubmit }) => {
  const [name, setName] = useState(guest.name);
  const [listName, setListName] = useState(guest.list_name);

  const footer = (
    <div className="d2-guest-modal-actions">
      <Button variant="secondary" onClick={onClose} disabled={submitting}>Cancel</Button>
      <Button variant="primary" onClick={() => onSubmit({ name, listName })} disabled={submitting || !name.trim()}>
        Save
      </Button>
    </div>
  );

  return (
    <Modal open onClose={onClose} icon={false} title="Edit guest" footer={footer}>
      <div className="d2-guest-modal-body">
        <TextInput label="Name" value={name} onChange={(event) => setName(event.target.value)} />
        <Select
          label="List"
          options={lists.map((list) => ({ value: list.name, label: list.name }))}
          value={listName}
          onChange={setListName}
        />
      </div>
    </Modal>
  );
};

EditGuestModal.propTypes = {
  guest: PropTypes.shape({ name: PropTypes.string, list_name: PropTypes.string }).isRequired,
  lists: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })).isRequired,
  submitting: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default EditGuestModal;
